import React from "react";
import { FormText } from "reactstrap";
import { LabSelector as BaseLabSelector } from "../LabSelector";
import { InputWrapper, serializeInput } from "./InputWrapper";

export const LabSelector = ({ children, input, label, meta, ...rest }) => {
  const invalid = Boolean(meta.touched && meta.error);

  return (
    <InputWrapper label={label} required={rest.required} data-testid={rest["data-testid"]}>
      <BaseLabSelector {...input} {...rest} valid={!invalid} />

      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}

      {children}
    </InputWrapper>
  );
};

export const SerializedLabSelector = serializeInput(LabSelector);
